<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <div class="mb15">
        <span class='mr15'>
          <a-button type="primary" v-has:systemRoleAdd="create">
            添加角色
          </a-button>
        </span>
      </div>
      <a-form ref='form' :model='search' :style="{'marginBottom':'10px'}" :initialValues="search" :onFinish='pageSearchChange' layout='inline'>
        <a-form-item label="关键词" name='name'>
          <a-input v-model:value="search.key" :style="{width:'250px'}" placeholder="请输入角色名称"></a-input>
        </a-form-item>
        <a-form-item label="用户状态" name='level'>
          <a-select v-model:value="search.status" :style="{width:'180px'}" placeholder="全部">
            <a-select-option value="">
              全部
            </a-select-option>
            <a-select-option :value="1">
              正常
            </a-select-option>
            <a-select-option :value="0">
              禁用
            </a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item>
          <a-button type="primary" htmlType='submit'>搜索</a-button>
        </a-form-item>
        <a-form-item>
          <a-button @click='pageSearchReset'>重置</a-button>
        </a-form-item>
      </a-form>
      <a-table :pagination='false' :loading='listLoading' bordered rowKey='id' :columns='columns' :data-source='data'>
        <template v-slot:status="{ record }">
          <span>{{record.status==1?'正常':'禁用'}}</span>
        </template>
        <template v-slot:role_name="{ record }">
          <a-tag color="#05486A" v-if='record.is_sys'>默认</a-tag>
          <span>{{record.role_name}}</span>
        </template>
        <template v-slot:action="{ record,index }">
            <a-button class="m-r-10" v-has:systemRoleEdit="()=>systemRoleSetting(record,index)" size="small" type="primary" :loading="record.loading">修改</a-button>
            <a-button v-has:systemRoleDel="()=>systemRoleDel(record)" size="small" type="primary" danger >删除</a-button>
        </template>
      </a-table>
      <!-- <a-pagination size="small" :style="{marginTop:'20px',textAlign:'right'}" :current="search.page" :page-size="search.limit" :total="total" show-size-changer show-quick-jumper @change="pageCurrentChange" @showSizeChange="pageSizeChange" /> -->
    </a-card>
  </a-layout>
  <!--新增角色-->
  <a-modal  :keyboard="false" v-model:visible="visible" centered :title="ruleFormData.id?'修改角色':'新增角色'" @ok="handleOk" @cancel="visible=false;activeKey=0;ruleFormData.rules=[];" :confirm-loading="confirmLoading" destroyOnClose :width='1200'>
    <a-form ref="ruleForm" :model="ruleFormData" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
      <a-form-item ref="role_name" label="角色名称" name="role_name" :rules="[{ required: true, message: '请输入角色名称' }]" :wrapper-col="{ span: 10 }">
        <a-input v-model:value="ruleFormData.role_name" />
      </a-form-item>
      <a-form-item ref="rules" label="角色权限" name="rules">
        <a-tabs v-model:activeKey="activeKey">
          <a-tab-pane v-for='(item,index) in tabsData' :key="index" :tab="item.app_name">
            <a-tree checkable :tree-data="item.menu"  v-model:checkedKeys="item.rules_id" :key="id" :replace-fields="{key:'id'}" @check="changeTree" :dropdownStyle="{'height':'300px'}" v-if='item.menu.length'>
            </a-tree >
            <a-empty v-else />
          </a-tab-pane>
        </a-tabs>
      </a-form-item>
    </a-form>
  </a-modal>
</template>
<script>
import { ref, onMounted, provide, inject, reactive, toRefs } from "vue";
import { message } from "ant-design-vue";
import {
  getRole,
  createRole,
  roleDetail,
  delRole,
  getMenu,
  editRole,
  statusRole,
} from "@/api/system";
import { iscode } from "@/utils/app";
import { getRouter } from "@/utils/app";
import { setPageState, getPageState } from "@/utils/pageState";
// 初始化默认筛选项数值
let defSearch = {
  key: "",
  status: "",
  page: 1,
  limit: 10,
};
let defForm = {
  role_name: "",
  rules: [],
  id: null,
};
export default {
  setup(props) {
    const state = reactive({
      confirmLoading:false,
      businessSelectedRowKeys:[],
      total: 0,
      data: [],
      visible: false,
      labelCol: { span: 3 },
      wrapperCol: { span: 21 },
      title: "新增角色",
      rules: {
        role_name: [
          {
            required: true,
            message: "请输入角色名称",
          },
        ],
      },
      listLoading: false,
      visibleSeting: false,
      activeKey:0,
      tabsData:[]
    });
    //初始化 分页信息和筛选项信息
    let total = ref(1);
    let search = ref({ ...defSearch });
    let columns = [
      {
        title: "角色ID",
        dataIndex: "id",
        key: "id",
      },
      {
        title: "角色",
        dataIndex: "role_name",
        key: "role_name",
        slots: { customRender: "role_name" },
      },
      // {
      //   title: "状态",
      //   dataIndex: "status",
      //   key: "status",
      //   slots: { customRender: "status" },
      // },
      {
        title: "操作",
        key: "action",
        width:200,
        slots: { customRender: "action" },
      },
    ];
    const getMenus = async () => {
      const hide = message.loading("正在加载中...", 0);
      let result = await getMenu().then((res) => res.data).catch((error) => error);
      result.data.forEach(v=>{
        if(v.menu.length){
          v.menu = handleTree(v.menu);
          v.rules_id = [];
        }
      })
      state.tabsData = result.data;
      state.visible = true;
      setTimeout(hide);
    };
    let _lodash = inject("_lodash");
    const handleTree = (data) => {
      _lodash.map(data, function (currentObject) {
        currentObject.value = currentObject.id;
        if (currentObject.children) {
          currentObject.children = handleTree(currentObject.children);
        }
      });
      return data;
    };
    // 页面筛选项搜索
    const pageSearchChange = () => {
      search.value = { ...search.value, page: 1 };
      initData(search.value);
    };
    // 页面筛选项重置
    const pageSearchReset = () => {
      search.value = {
        ...defSearch,
        page: search.value.page,
        limit: search.value.limit,
      };
    };
    // 分页当前页切换
    const pageCurrentChange = (page, pageSize) => {
      search.value.page = page;
      initData(search.value);
    };
    // 分页当前页显示多少条切换
    const pageSizeChange = (current, limit) => {
      search.value.page = 1;
      search.value.limit = limit;
      initData(search.value);
    };
    const initData = async (values) => {
      state.listLoading = true;
      state.data = [];
      let result = await getRole(values)
        .then((res) => res.data)
        .catch((error) => error);
      state.listLoading = false;
      if (iscode(result)) {
        state.data = result.data;
        state.total = result.data.total;
      }
    };
    onMounted(() => {
      initData(search.value);
    });
    //新增角色
    const ruleForm = ref();
    const ruleFormData = ref({ ...defForm });
    const create = function () {
      ruleFormData.value = {
        role_name: "",
        rules: [],
        id: null,
      };
      getMenus();
    };
    const handleOk = () => {
      var rules_id = [];
      state.tabsData.forEach(v=>{
        if(v.rules_id && v.rules_id.length){
          console.log(v.rules_id)
          rules_id = _lodash.concat(rules_id,v.rules_id)
        }
      })
      if(!rules_id.length){
        message.error('请选择权限！')
        return
      }
      state.confirmLoading=true
      ruleForm.value.validate().then(async (e) => {
        let result;
        if (ruleFormData.value.id) {result = await editRole({...ruleFormData.value,rules:rules_id.join(','),role_id: ruleFormData.value.id,}).then((res) => res.data).catch((error) => error);
        } else {
          result = await createRole( {...ruleFormData.value,rules:rules_id.join(',')}).then((res) => res.data).catch((error) => error);
        }
          state.confirmLoading=false
        if (iscode(result, true)) {
          ruleForm.value.resetFields();
          state.visible = false;
          initData(search.value);
          state.activeKey = 0;
        }
      }).catch((error) => {});
    };
    // 设置权限
    const $router = inject("$router");
    const systemRoleSetting = async (data,index) => {
      if(data.is_sys){
        message.error('默认角色不可进行操作！')
        return
      }
      const hide = message.loading("正在加载中...", 0);
      state.data[index].loading = true;
      let result = await getMenu({ role_id: data.id }).then((res) => res.data).catch((error) => error);
      if (iscode(result)) {
        // 设置修改的值
        ruleFormData.value["id"] = data.id;
        ruleFormData.value["role_name"] =data.role_name;
        result.data.forEach(v=>{
          if(v.menu.length){
            v.menu = handleTree(v.menu);
            v.rules_id = _lodash.map(v.rules, 'id');
          }
        })
        state.tabsData = result.data;
        // 打开弹窗
        setTimeout(()=>{
          state.visible = true;
        },100)
      }else {
        message.error(result.msg);
      }
      state.data[index].loading = false;
      setTimeout(hide);
    };
    // 角色删除
    const $Modal = inject("$Modal");
    const systemRoleDel = (data) => {
      if(data.is_sys){
        message.error('默认角色不可进行操作！')
        return
      }
      $Modal.confirm({
        centered: true,
        content: "确认删除所选角色",
        onOk: () => {
          delRole(data.id).then((res) => {
            if (iscode(res.data, true)) {
              initData(search.value);
            }
          }).catch((error) => error);
        },
      });
    };
    const systemRoleEdit = async (data) => {
      let result = await roleDetail(data.id)
        .then((res) => res.data)
        .catch((error) => error);
      let { id, is_super, role_name } = data;
      ruleFormData.value["id"] = id;
      ruleFormData.value["is_super"] = is_super;
      ruleFormData.value["role_name"] = role_name;
      // 打开弹窗
      state.visible = true;
    };

    const systemRoleStatus = async (data) => {
      $Modal.confirm({
        centered: true,
        content: `确定${status ? "启用" : "禁用"}该角色？`,
        onOk: async () => {
          let result = await statusRole(status, data.id)
            .then((res) => res.data)
            .catch((error) => error);
          if (iscode(result, true)) {
            initData(search.value);
          }
        },
      });
    };
    // 树形图 勾选时
    const changeTree=(checkedKeys)=>{
      state.tabsData[state.activeKey].rules_id = checkedKeys;
    }
    return {
      ...toRefs(state),
      ruleForm,
      ruleFormData,
      search,
      columns,
      pageSearchChange,
      pageSearchReset,
      pageCurrentChange,
      pageSizeChange,
      create,
      handleOk,
      systemRoleSetting,
      systemRoleDel,
      systemRoleEdit,
      systemRoleStatus,
      changeTree,
      getMenus
    };
  },
};
</script>